export default __webpack_public_path__ + "static/media/x0pa-brown.2c0226a9.png";